export default "__VITE_ASSET__CifQmFtZ__"